import { Modal } from '@zendeskgarden/react-modals';
import type { PropsModal } from './interface';
import { Button } from '@/components';

export function ModalContainer({ sendCancel, title, content, onClose, isDanger, disabled }: PropsModal) {
    return (
        <Modal onClose={onClose}>
            <Modal.Header tag="h4" isDanger={isDanger}>
                {title}
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
            <Modal.Footer>
                <Modal.FooterItem>
                    <Button
                        onClick={onClose}
                        isDanger={isDanger}
                        isBasic
                        disabled={disabled}
                    >
                        Cancelar
                    </Button>
                </Modal.FooterItem>
                <Modal.FooterItem>
                    <Button
                        isDanger={isDanger}
                        isPrimary
                        onClick={sendCancel}
                        disabled={disabled}
                    >
                        Confirmar
                    </Button>
                </Modal.FooterItem>
            </Modal.Footer>
            <Modal.Close aria-label="Close modal" />
        </Modal>
    );
}
